













import { defineComponent, nextTick, PropType, ref, toRef, watch } from "@vue/composition-api";
import { PurchasedItem } from "@scrile/api-provider/dist/api/PurchasedItemsProvider";
import InfiniteScroll from "@/components/InfiniteScroll/InfiniteScroll.vue";
import PurchaseItemFeedView from "../PurchaseItemFeedView";

export default defineComponent({
  name: "GalleryFeed",
  components: { InfiniteScroll },
  props: {
    items: { type: Array as PropType<PurchasedItem[]>, required: true },
    enableScroll: { type: Boolean, default: true },
    selectedItemId: { type: String },
  },
  setup(props, { root }) {
    const feeds = ref();
    const scrollToIndex = ref(0);
    const getItemView = PurchaseItemFeedView;

    const scrollToFeedWatcher = async (feedIdNew?: string | null) => {
      if (!feedIdNew) return;
      const selectedIndex = props.items.findIndex(i => i.id === feedIdNew);
      scrollToIndex.value = selectedIndex;
      if (selectedIndex > 0) {
        await nextTick();
        const el = root.$el.querySelector(`[data-id="${feedIdNew}"]`);
        el && el.scrollIntoView({ block: "start", behavior: "auto" });
      } else {
        window.scrollTo({ top: 0 });
      }
    };

    watch(toRef(props, "selectedItemId"), scrollToFeedWatcher, { immediate: true });

    return { scrollToIndex, feeds, getItemView };
  },
});
